const { default: axiosInstance, endpoints } = require('src/utils/axios-visa');

/* eslint-disable class-methods-use-this */

class FaqService {
  getFaqs = async (countryCode) => {
    const resp = await axiosInstance.get(endpoints.faqs.details(countryCode));
    return resp.data;
  };
}

const faqService = new FaqService();
export default faqService;
